export default "__VITE_ASSET__DwmWTyAp__"